<template>
<span>

      <v-text-field
          @click:clear="returnsGroupListWhenCleared"
          @keyup="returnsGroupListWhenNull"
          class="mt-2 mb-2"
          dense
          clearable
          hide-details
          outlined
          v-model="search"
          placeholder="Search Group"
          prepend-inner-icon="mdi-magnify"
          v-on:keyup.enter="filterList"
      ></v-text-field>




            <v-divider></v-divider>


          <div
              ref="groupScroller"
              class="list-scroller"
              @scroll="onScroll"
              @wheel="onWheel"
              @touchstart="onTouchStart"
              @touchmove="onTouchMove"
          >

             <v-progress-linear
                 v-if="groupLoader"
                 indeterminate
                 color="#242f7e"
                 class="mb-0"
                 height="2"
             ></v-progress-linear>

                <v-list
                    v-for="item in groupList"
                    :key="item.number"
                    subheader
                >
                  <v-list-item-group
                      :v-model="item.number"
                  >
                    <v-list-item
                        style="border-bottom: 0.5px solid #f1f1f1;"
                        @click.prevent="selectUserContact(item)"
                        link>

                      <v-list-item-avatar>
                        <v-icon large>
                          mdi-account-multiple-outline
                        </v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                        <small class="text-truncate" v-text="item.description"></small>
                      </v-list-item-content>

                        <v-list-item-action>


                         <v-menu
                             bottom
                             left
                             open-on-hover

                         >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                       <v-card width="180">
                          <v-list dense>
                            <v-list-item @click="editGroup(item)">
                              <small>Edit Group</small>
                            </v-list-item>
                          </v-list>
                      </v-card>
                        </v-menu>

                      </v-list-item-action>

                    </v-list-item>

                  </v-list-item-group>

                </v-list>

              <div v-if="loadFailed" class="load-more-wrap">
                <button
                    type="button"
                    class="load-more-btn"
                    :disabled="groupLoader"
                    @click.stop="retryGroupLoad"
                >
                  Load more
                </button>
              </div>

  </div>



<v-dialog
    transition="dialog-bottom-transition"
    v-model="editGroupDialog"
    width="42%"
>

      <v-card>
         <v-toolbar dense flat>
          <v-toolbar-title>Edit Group</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-icon
                color="red"
                @click="editGroupDialog = false"
            >
             mdi-close
            </v-icon>
         </v-toolbar>
        <v-divider></v-divider>

         <v-card class="mx-auto pb-4 mt-6" width="96%" flat>

           <new-group :groupInfo="groupInfo" ref="edit_group_component"></new-group>

         </v-card>


      </v-card>
    </v-dialog>




</span>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import NewGroup from "@/views/Main/Groups/NewGroup";

export default {
  name: "MessengerGroups",
  components: {NewGroup},
  data(){
    return{
      search:"",
      groupList:[],
      groupLoader:false,
      loadFailed:false,
      scrollReady:true,
      loadedScrollHeight:0,
      hasMoreGroups:true,
      items_per_page: 13,
      page: 1,
      pendingPage: 1,
      touchStartY: 0,
      groupContactDialog:false,
      editGroupDialog:false,
      groupInfo:{}
    }
  },
  mounted() {
    if(this.$route.query.q){
      this.search = this.$route.query.q
    }
    this.fetchListContacts()
  },
  methods:{
    ...mapActions(
      [
          "fetchGroups",
          "groupMessages",
          "fetchGroupProfile"
      ]
    ),
    selectUserContact(item){

      //fetch group messages
      let options = {
        page: 1,
        per_page: 11,
        contact_number: item.number,
        // search: "",
      }
      this.groupMessages(options)

      //fetch group details
      let optionsData = {
        page: 1,
        per_page: 11,
        group_number: item.number,
        search: "",
      }
      this.fetchGroupProfile(optionsData)


    },
    filterGroupData(data){
      let dataObj = data.data || [];
      let current_page = (data.page * 1);
      if (current_page > 0 && this.pendingPage && current_page !== this.pendingPage) {
        return
      }
      this.page = current_page > 0 ? current_page : 1;
      this.hasMoreGroups = dataObj.length >= this.items_per_page;
      this.loadFailed = false

      let per_page = data.per_page;
      this.items_per_page = (per_page * 1) || this.items_per_page;

      this.groupLoader = false
      let jsn = {};

      dataObj.forEach(list =>{
        jsn = {
          title: list.grp_name,
          description: list.grp_desc,
          number: list.number,
        }

        const index = this.groupList.findIndex(object => object.number === jsn.number);

        if (index === -1) {
          this.groupList.push(jsn);
        }

      })
    },
    filterList(){
      this.groupList = []
      this.page = 1
      this.hasMoreGroups = true
      this.loadFailed = false
      this.scrollReady = true
      this.loadedScrollHeight = 0
      this.groupLoader = false
      this.loadGroupPage(1)
    },
    fetchListContacts(){
      this.groupList = []
      this.page = 1
      this.hasMoreGroups = true
      this.loadFailed = false
      this.scrollReady = true
      this.loadedScrollHeight = 0
      this.groupLoader = false
      this.loadGroupPage(1)
    },
    retryGroupLoad(){
      this.loadFailed = false
      this.groupLoader = false
      this.loadGroupPage(this.pendingPage || 1)
    },
    groupsListIsVisible() {
      return this.$route.query.type === "grp"
    },
    loadGroupPage(page){
      if (this.groupLoader || !this.hasMoreGroups) {
        return
      }
      if (page > 1 && !this.groupsListIsVisible()) {
        return
      }
      this.groupLoader = true
      this.pendingPage = page
      this.fetchGroups({
        page: page,
        per_page: this.items_per_page,
        search: this.search,
      })
    },
    onScroll(event) {
      const target = event && event.target ? event.target : null
      this.requestNextPage(target, false)
    },
    onWheel(event) {
      if (!event || event.deltaY <= 0) {
        return
      }
      this.requestNextPage(this.$refs.groupScroller, true)
    },
    onTouchStart(event) {
      const touch = event.touches && event.touches[0]
      this.touchStartY = touch ? touch.clientY : 0
    },
    onTouchMove(event) {
      const touch = event.touches && event.touches[0]
      if (!touch || this.touchStartY - touch.clientY < 12) {
        return
      }
      this.requestNextPage(this.$refs.groupScroller, true)
    },
    requestNextPage(target, fromUserGesture) {
      if (!this.groupsListIsVisible() || !target || this.groupLoader || !this.hasMoreGroups || this.loadFailed) {
        return
      }
      if (target.clientHeight < 40) {
        return
      }
      const distanceFromBottom = target.scrollHeight - (target.scrollTop + target.clientHeight)
      if (distanceFromBottom > 160) {
        this.scrollReady = true
        return
      }
      if (target.scrollHeight <= this.loadedScrollHeight) {
        return
      }
      if (!fromUserGesture && (target.scrollTop <= 0 || !this.scrollReady)) {
        return
      }
      this.scrollReady = false
      this.loadedScrollHeight = target.scrollHeight
      this.loadGroupPage(this.page + 1)
    },
    editGroup(item){
      this.editGroupDialog = true
      this.groupInfo = item
    },
    returnsGroupListWhenNull(){
      if(!this.search){
        this.filterList()
      }
    },
    returnsGroupListWhenCleared(){
        this.search = ""
        this.filterList()
    }
  },
  computed:{
    ...mapGetters(
        [
            "getGroupListFile",
            "getNewGroupError",
            "getUpdateGroupInfo"
        ]
    )
  },
  watch:{
    getGroupListFile(data){
      if(data){
        this.filterGroupData(data)

        //if no contact is selected then with use the first contact to display its data
        if(data.page === 1) {
          if (this.$route.query.type === 'grp') {

            if(this.groupList.length > 0) {
              let groupNumber = this.groupList[0].number
              this.selectUserContact({number: groupNumber})
            }

          }
        }

      }
    },
    getNewGroupError(data){
      if(data && this.groupLoader){
        this.groupLoader = false
        this.loadFailed = true
        this.scrollReady = true
      }
    },
    getUpdateGroupInfo(data){
      if(data){
        this.editGroupDialog = false
        this.$refs["edit_group_component"].spinner = false
        this.$refs["edit_group_component"].form = {
          group_name:null,
          grp_desc:null,
        }
        this.fetchListContacts()
        this.successToast("Success", data.message)
      }
    }
  }
}
</script>

<style scoped>
.list-scroller {
  height: 70vh;
  overflow-y: auto;
}
.load-more-wrap {
  display: flex;
  justify-content: center;
  padding: 12px 0 16px;
}
.load-more-btn {
  border: 1px solid #242f7e;
  background: transparent;
  color: #242f7e;
  border-radius: 999px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
}
.load-more-btn:disabled {
  opacity: 0.55;
  cursor: default;
}
.activeClass{
  background-color: #e4e4e4;
}
</style>